import React from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Button } from 'antd';

const style = {
  button: {
    width: '100%',
  },
};

const Buttons = ({ handleSubmit, isValid, isLast }) => {
  return (
    <Row gutter={10}>
      <Col span={12} offset={12}>
        <Button
          disabled={!isValid || !isLast}
          onClick={handleSubmit}
          type="primary"
          style={style.button}
          data-test="next"
        >
          Create
        </Button>
      </Col>
    </Row>
  );
};

Buttons.propTypes = {
  handleSubmit: PropTypes.func.isRequired,
  isValid: PropTypes.bool.isRequired,
  isLast: PropTypes.bool.isRequired,
};

export default Buttons;
